import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../../shared/Modal'
import WarningIcon from '../../ui/icons/WarningIcon'

const HEADER_CLASS = 'tw:flex tw:justify-end tw:px-4 tw:pt-4'
const CLOSE_CLASS = 'tw:bg-transparent tw:border-0 tw:p-0 tw:cursor-pointer tw:text-gray-400 tw:text-lg'
const ICON_WRAP_CLASS = 'tw:flex tw:justify-center tw:mb-3'
const ICON_BADGE_CLASS = 'tw:inline-flex tw:items-center tw:justify-center '
  + 'tw:size-12 tw:rounded-lg! tw:bg-ds-progress-lowest'
const ICON_CLASS = 'tw:size-6 tw:text-ds-warning'
const TITLE_CLASS = 'tw:text-center tw:text-base tw:font-medium tw:text-gray-900 tw:mb-2 tw:m-0!'

const WarningModal = ({ isOpen, title, footer, onClose, children }) => {
  const header = (
    <div className={HEADER_CLASS}>
      <button aria-label="Fermer la modale" className={CLOSE_CLASS} type="button" onClick={onClose}>
        <i aria-hidden="true" className="fas fa-times" />
      </button>
    </div>
  )

  return (
    <Modal footer={footer} header={header} isOpen={isOpen} size="md" title={title} onClose={onClose}>
      <div className={ICON_WRAP_CLASS}>
        <span className={ICON_BADGE_CLASS}>
          <WarningIcon className={ICON_CLASS} />
        </span>
      </div>
      <p className={TITLE_CLASS}>{title}</p>
      {children}
    </Modal>
  )
}

WarningModal.propTypes = {
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
}

WarningModal.defaultProps = {
  footer: null
}

export default WarningModal
